import React from 'react'
import PropTypes from 'prop-types'
import { Style } from 'react-style-tag'

import { isClient } from '@cred/shared/utils'

const CustomStylesSheet = ({ styles, className }) => {
  if (!isClient()) return null

  return (
    <Style>
      {`
        .${className} {
          ${styles.primaryColor ? `--primary-color: ${styles.primaryColor};` : ''}
          ${styles.secondaryColor ? `--secondary-color: ${styles.secondaryColor};` : ''}
          ${styles.fontWeight ? `--custom-font-weight: ${styles.fontWeight};` : ''}
          ${styles.fontFamilyRegular ? `--custom-regular-font-family: ${styles.fontFamilyRegular};` : ''}
          ${styles.fontFamilySemiBold ? `--custom-semi-bold-font-family: ${styles.fontFamilySemiBold};` : ''}
          ${styles.fontFamilyBold ? `--custom-bold-font-family: ${styles.fontFamilyBold};` : ''}
          ${styles.fontFamilyExtraBold ? `--custom-extra-bold-font-family: ${styles.fontFamilyExtraBold};` : ''}
          ${styles.fontWeightRegular ? `--custom-regular-font-weight: ${styles.fontWeightRegular};` : ''}
          ${styles.fontWeightSemiBold ? `--custom-semi-bold-font-weight: ${styles.fontWeightSemiBold};` : ''}
          ${styles.fontWeightBold ? `--custom-bold-font-weight: ${styles.fontWeightBold};` : ''}
          ${styles.fontWeightExtraBold ? `--custom-extra-bold-font-weight: ${styles.fontWeightExtraBold};` : ''}
        
        }
      `}
    </Style>
  )
}

CustomStylesSheet.propTypes = {
  className: PropTypes.string.isRequired,
  styles: PropTypes.shape({
    primaryColor: PropTypes.string,
    secondaryColor: PropTypes.string,
    fontWeight: PropTypes.string,
    fontFamilyRegular: PropTypes.string,
    fontFamilySemiBold: PropTypes.string,
    fontFamilyBold: PropTypes.string,
    fontFamilyExtraBold: PropTypes.string,
    fontWeightRegular: PropTypes.string,
    fontWeightSemiBold: PropTypes.string,
    fontWeightBold: PropTypes.string,
    fontWeightExtraBold: PropTypes.string,
  })
}

export default CustomStylesSheet
